import { connect } from "react-redux";
import { withTranslation } from "react-i18next";

import * as actions from "../constants/actions";
import ModelExport from "../components/ModelExport";

const mapStateToProps = state => ({
  modelExport: state.modelExports.byIds[state.modelExports.allIds[0]],
  query: state.router.query,
  lng:  state.locale.lng
});


const mapDispatchToProps = dispatch => ({
  hideHeader: () => dispatch(actions.hideUIHeader()),
  showHeader: () => dispatch(actions.showUIHeader()),
});

const connectedComponent = connect(
  mapStateToProps,
  mapDispatchToProps
)(ModelExport);
const withTranslationComponent = withTranslation(["common", "pdf"])(connectedComponent);

export default withTranslationComponent;



// WEBPACK FOOTER //
// ./src/containers/ModelExport.js